export default __webpack_public_path__ + "static/media/outside.3c2e337e.jpg";